import http from '@/http'

export default class EstadoInscricaoService {
 
    getEstadosInscricao() {
      console.log('getEstadosInscricao ...');
      return http.get('inscricao/estados-inscricoes').then(res => res.data);
    }

}
